import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@mui/material';
import { colors } from '@/globalStyles';
import {
  Header,
  SchemasRenderingArea,
  OptionPanel,
  LoginRequiredModal,
  WebSaveProjectModal,
  VariantColorModal,
  KeyboardShortcutsModal
} from '@/components';
import { CTAPanel } from './components';
import {
  PageWrapperStyled,
  BodyStyled,
  CanvasStyled,
  OptionPanelWrapperStyled,
  FloatableSectionContentTextareaStyled
} from './styles';

const Home = () => {
  const isLoginRequiredModalOpen = useSelector((state) => state.cmmeReducer.isLoginRequiredModalOpen);
  const isSaveProjectModalOpen = useSelector((state) => state.cmmeReducer.isSaveProjectModalOpen);
  const isVariantColorModalOpen = useSelector((state) => state.core.isVariantColorModalOpen);
  const isShortcutModalOpen = useSelector((state) => state.cmmeReducer.isShortcutModalOpen);
  const pageWrapperRef = useRef(null);

  useEffect(() => {
    if (pageWrapperRef.current) {
      pageWrapperRef.current.addEventListener('contextmenu', function(event) {
        event.preventDefault();
      });
    }
  }, []);

  return (
    <>
      <PageWrapperStyled ref={pageWrapperRef}>
        <Header />
        <Box sx={{ backgroundColor: colors.backgroundBody, zIndex: 1 }} />
        <BodyStyled>
          <CanvasStyled>
            <SchemasRenderingArea />
          </CanvasStyled>
          <Box sx={{ backgroundColor: colors.backgroundBody, zIndex: 1 }} />
          <OptionPanelWrapperStyled>
            <OptionPanel />
            <CTAPanel />
          </OptionPanelWrapperStyled>
        </BodyStyled>
      </PageWrapperStyled>

      <FloatableSectionContentTextareaStyled id="floatable-section-content-textarea-portal" />

      <div id="background-printing" />

      {isLoginRequiredModalOpen && <LoginRequiredModal />}
      {isSaveProjectModalOpen && <WebSaveProjectModal />}
      {isVariantColorModalOpen && <VariantColorModal />}
      {isShortcutModalOpen && <KeyboardShortcutsModal />}
    </>
  );
};

export default Home;
